<template>
    <div class="EmptyRequirementTypes">
        <img class="EmptyRequirementTypes__icon" :src="docWithExclamationMark" alt="docWithExclamationMark">
        <div class="EmptyRequirementTypes__titleText">
            No Details Available
        </div>
        <p>
            This entity has not yet been assigned to a risk profile.
        </p>
        <p>
            Risk requirements will be displayed here once they've been assigned.
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import docWithExclamationMark from '@/modules/dashboard/assets/doc-with-exclamation-mark.svg';

    @Component({
        components: {
            FontAwesomeIcon,
        },
    })
    export default class EmptyRequirementTypes extends Vue {
        private docWithExclamationMark = docWithExclamationMark;
    }
</script>
